export default {
  name: "AppTabs",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    tabs: {
      type: Array,
      default: () => []
    },
    enabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lineStyle: "",
      hoveringTab: ""
    };
  },
  watch: {
    modelValue(val) {
      this.calcLineStyle(val);
    }
  },
  computed: {
    computedStyle() {
      return {
        "--active-bg": this.tabs.find(tab => tab.value == this.modelValue).activeBg,
        "--active-color": this.tabs.find(tab => tab.value == this.modelValue).activeColor
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcLineStyle(this.modelValue);
    });
  },
  methods: {
    calcLineStyle(val) {
      const ref = this.$refs[`ref-${val}`]?.[0];
      if (ref) {
        const left = ref.getBoundingClientRect().left - ref.parentNode.getBoundingClientRect().left;
        const width = ref.offsetWidth;
        this.lineStyle = `width: ${width}px; left: ${left}px;`;
      }
    },
    onTabChange(tab) {
      if (tab.canSwitchTab()) {
        this.$emit("update:modelValue", tab.value);
      }
    }
  }
};